import { useEffect } from 'preact/hooks';
import { useQuery } from '@tanstack/react-query';
import { getPortalTerrain3dCards } from '../../lib/portal-detail-api.js';
import ParcelMorphologyThreeCard from '../parcelMorphology/ParcelMorphologyThreeCard/ParcelMorphologyThreeCard.jsx';
import ParcelSlopeThreeCard from '../parcelSlope/ParcelSlopeThreeCard/ParcelSlopeThreeCard.jsx';
import TerrainBandBackToMapButton from './TerrainBandBackToMapButton.jsx';

/**
 * Terrain band harita alanında tam eğim / morfoloji 3D kartı overlay.
 * @param {'slope'|'morphology'|null} mode
 */
export default function TerrainBandMeshExpandOverlay({
  mode = null,
  snapshotId = null,
  onClose,
}) {
  const enabled = Boolean(mode && snapshotId);

  const slopeQuery = useQuery({
    queryKey: ['portal-terrain-3d-cards', snapshotId],
    queryFn: () => getPortalTerrain3dCards(snapshotId),
    select: (data) => data?.slope ?? null,
    enabled: enabled && mode === 'slope',
    staleTime: 60_000,
    retry: false,
  });

  const morphQuery = useQuery({
    queryKey: ['portal-terrain-3d-cards', snapshotId],
    queryFn: () => getPortalTerrain3dCards(snapshotId),
    select: (data) => data?.morphology ?? null,
    enabled: enabled && mode === 'morphology',
    staleTime: 60_000,
    retry: false,
  });

  useEffect(() => {
    if (!mode) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [mode, onClose]);

  if (!mode) return null;

  const title = mode === 'slope' ? 'parsel egim analizi' : 'parsel baglam morfolojisi';
  const loading = mode === 'slope'
    ? (slopeQuery.isLoading && !slopeQuery.data)
    : (morphQuery.isLoading && !morphQuery.data);
  const error = mode === 'slope'
    ? (slopeQuery.isError ? (slopeQuery.error?.message || '3D eğim yüklenemedi') : null)
    : (morphQuery.isError ? (morphQuery.error?.message || '3D morfoloji yüklenemedi') : null);

  return (
    <div className="pp-detail-terrain-band__mesh-expand" role="dialog" aria-modal="true" aria-label={title}>
      <div className="pp-detail-terrain-band__mesh-expand-bar">
        <span className="pp-detail-terrain-band__mesh-expand-title">{title}</span>
        <div className="pp-detail-terrain-band__mesh-expand-actions">
          <TerrainBandBackToMapButton onClick={onClose} />
        </div>
      </div>
      <div className="pp-detail-terrain-band__mesh-expand-body">
        {mode === 'slope' ? (
          loading ? (
            <div className="pp-detail-terrain-band__mesh-expand-skel" aria-busy="true" />
          ) : error ? (
            <div className="pp-detail-terrain-band__mesh-expand-err" role="status">{error}</div>
          ) : slopeQuery.data ? (
            <ParcelSlopeThreeCard data={slopeQuery.data} />
          ) : null
        ) : (
          loading ? (
            <div className="pp-detail-terrain-band__mesh-expand-skel" aria-busy="true" />
          ) : error ? (
            <div className="pp-detail-terrain-band__mesh-expand-err" role="status">{error}</div>
          ) : morphQuery.data ? (
            <ParcelMorphologyThreeCard data={morphQuery.data} />
          ) : null
        )}
      </div>
    </div>
  );
}
